// import {GetListParams, InputProps, useDataProvider, useGetList, useInput} from 'ra-core';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import {ReactNode, useCallback, useEffect, useMemo, useState} from 'react';
import clsx from 'clsx';
import {ChoiceProps} from 'hooks/types';
import {InputProps, useInput} from '@/hooks/useInput';
import {BaseRecord, CrudFilters, useDataProvider, useList, UseListProps} from '@refinedev/core';
import _, {debounce, set} from 'lodash';
import {Label} from '@/shadcn_components/ui/label';
import Autocomplete2, {AutocompleteProps} from '../basic/Autocomplete2';

export type AutocompleteInputProps = InputProps & {
  inputDebounce?: number;
  reference: string;
  refetchFullValue?: boolean;
  autoCompleteProps?: Partial<AutocompleteProps>;
  renderPreview?: (item?: ChoiceProps) => ReactNode;
  // build filter from text input
  buildFilter?: (text: string) => CrudFilters;
} & React.ComponentProps<'div'> &
  Partial<UseListProps<BaseRecord, unknown, BaseRecord>>;

const AutocompleteInput = (props: AutocompleteInputProps) => {
  const {
    reference,
    className,
    autoCompleteProps,
    renderPreview,
    pagination = {current: 0, pageSize: 30},
    sorters = [{field: 'id', order: 'asc'}],
    filters: initialFilter = [],
    meta,
    buildFilter = (text: string) => [
      {
        field: '_search',
        operator: 'contains',
        value: text,
      },
    ], //default filter
    refetchFullValue,
    inputDebounce = 200,
    placeholder,
    ...rest
  } = props;

  const {
    optionText = 'label',
    getOptionText = choice => choice?.[optionText] || String(choice?.id),
  } = autoCompleteProps || {};

  const dataProvider = useDataProvider()();

  // input props
  const {
    field: {onChange, value},
    fieldState,
  } = useInput({
    ...rest,
  });

  const [filters, setFilters] = useState<any>(initialFilter);

  const {data, isFetching} = useList({
    resource: reference,
    sorters,
    filters,
    pagination,
    meta,
  });
  const availableChoices = data?.data || [];

  // const [selectedItem, setSelectedItem] = useState<ChoiceProps | undefined>(undefined);

  // items changed, inform form
  // useEffect(() => {
  //   console.log('item changed', selectedItem);
  //   onChange(selectedItem);
  // }, [selectedItem]);

  // load full value data when mounted
  // async function loadFullValue() {
  //   if (!value) return;
  //   if (value.id) {
  //     setSelectedItem(value);
  //     return;
  //   }

  //   try {
  //     const {data} = await dataProvider.getOne({
  //       resource: reference,
  //       id: value,
  //       meta,
  //     });
  //     setSelectedItem(data);
  //   } catch (err) {
  //     //
  //   }
  // }

  // value change effect
  // useEffect(() => {
  //   loadFullValue(); //next tick
  // }, [value]);

  const onSearch = useMemo(
    () =>
      _.debounce((text: string) => {
        setFilters(buildFilter(text));
      }, 300),
    [buildFilter],
  );

  if (props.hidden) return null;

  return (
    <div className={clsx('form-control w-full', className)}>
      <Label>{props.label}</Label>

      <div className={clsx('relative')}>
        {/* auto complete input */}
        <Autocomplete2
          placeholder={placeholder}
          choices={availableChoices || []}
          onInputChange={onSearch}
          getOptionValue={v => v} //value is item itself
          isLoading={isFetching}
          value={value}
          // valueNullable
          // isMore={pageInfo?.hasNextPage}
          onSelect={choice => {
            // setSelectedItem(choice);
            onChange(choice);
            // addItem(choice);
            onSearch(''); //clear search
          }} //when autocomplete select item
          clearSearchOnSelect={true}
          {...autoCompleteProps}
        />
        {/* render preview items */}
        {renderPreview?.(value)}
      </div>
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export default AutocompleteInput;

// import AutocompleteInput, { AutocompleteInputProps } from './AutocompleteInput';

// export type AutocompleteInputProps = AutocompleteInputProps;

// const AutocompleteInput = (props: AutocompleteInputProps) => {
//   return <AutocompleteInput {...props}/>
// };

// export default AutocompleteInput;
